import React, {useEffect} from 'react';

export const CartEmptyContent = () => {
  const cartCollections = window.theme.cartCollections;

  useEffect(() => {
    const cartBottomContainer = document.querySelector('.cart-page-bottom');
    if (!cartBottomContainer) return;
    cartBottomContainer.remove();
  }, []);

  return (
    <div className="side-cart__content-container">
      <div className="side-cart__content">
        <div className="side-cart__empty">
          <span className="h7">{window.theme.strings.cartEmpty}</span>
          {cartCollections && (
            <ul class="side-cart__collection-links list-none">
              {cartCollections.cartCollectionOne && (
                <li>
                  <a href={cartCollections.cartCollectionOneLink} className="btn btn--secondary btn--block">
                    Shop {cartCollections.cartCollectionOne}
                  </a>
                </li>
              )}
              {cartCollections.cartCollectionTwo && (
                <li>
                  <a href={cartCollections.cartCollectionTwoLink} className="btn btn--secondary btn--block">
                    Shop {cartCollections.cartCollectionTwo}
                  </a>
                </li>
              )}
              {cartCollections.cartCollectionThree && (
                <li>
                  <a href={cartCollections.cartCollectionThreeLink} className="btn btn--secondary btn--block">
                    Shop {cartCollections.cartCollectionThree}
                  </a>
                </li>
              )}
              {cartCollections.cartCollectionFour && (
                <li>
                  <a href={cartCollections.cartCollectionFourLink} className="btn btn--secondary btn--block">
                    Shop {cartCollections.cartCollectionFour}
                  </a>
                </li>
              )}
            </ul>
          )}
        </div>
      </div>
    </div>
  );
};
